<template>
  <div class="app-container">
    <div>
      <div style="padding: 10px">
        <el-button type="primary" style="margin-left: 4px" @click="newAdd"
          >新增</el-button
        >
        <el-button type="primary" style="margin-left: 4px" @click="open"
          >单据选择</el-button
        >
        <el-button
          type="primary"
          style="margin-left: 4px"
          @click="save"
          :disabled="Status === 2"
          >保存</el-button
        >
        <el-button
          type="primary"
          style="margin-left: 4px"
          @click="handleDelete"
          :disabled="!isSave || Status === 2"
          >删除</el-button
        >
        <el-button
          type="primary"
          style="margin-left: 4px"
          @click="reView"
          v-if="Status !== 2"
          :disabled="!isSave"
          >审核</el-button
        >
        <el-button
          type="primary"
          style="margin-left: 4px"
          @click="cancelReView"
          v-if="Status === 2"
          :disabled="!isSave"
          >弃审</el-button
        >
        <!-- <el-dropdown style="margin-left: 4px">
          <el-button type="primary" :disabled="!isSave">
            联查<i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown" style="margin-left: 4px">
            <el-dropdown-item class="dropdown-item"
              >采购订单情况</el-dropdown-item
            >
            <el-dropdown-item class="dropdown-item">盘点单情况</el-dropdown-item>
            <el-dropdown-item class="dropdown-item"
              >组装拆卸单情况</el-dropdown-item
            >
            <el-dropdown-item class="dropdown-item"
              >形态转换单情况</el-dropdown-item
            >
            <el-dropdown-item class="dropdown-item">凭证情况</el-dropdown-item>
            <el-dropdown-item class="dropdown-item">其他出库单</el-dropdown-item>
            <el-dropdown-item class="dropdown-item">调拨单</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown> -->
        <el-button type="primary" style="margin-left: 4px" :disabled="!isSave"
          >打印</el-button
        >
      </div>
      <el-form
        :model="data"
        ref="form"
        :inline="true"
        :line-form="true"
        label-width="100px"
        status-icon
      >
        <el-row style="margin-top: 18px">
          <el-form-item label="单据日期" required>
            <span class="not-edit" v-if="Status === 2">{{ $commonJs.toDateString(data.DocDate) }}</span>
            <el-date-picker
              v-else
              v-model="data.DocDate"
              type="date"
              value-format="yyyy-MM-dd"
              format="yyyy-MM-dd"
              placeholder="选择日期"
              style="width: 180px"
              @change="(v) => getPreviewNo(v)"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="单据编码" required> 
            <span
              style="display: inline-block; width: 180px"
              v-if="Mode == 0"
              class="detail-span"
              >{{ data.DocNo }}</span
            >
            <el-input
              style="width: 180px"
              v-else
              v-model="data.DocNo"
              placeholder="请输入单据编码"
            ></el-input>
          </el-form-item>
          <el-form-item label="经手人:" prop="EmpId" label-width="100px"> 
            <span class="not-edit" v-if="Status === 2">{{ data.EmpName }}</span>
            <select-input
              v-else
              placeholder="请选择经办人"
              :label="data.EmpName"
              v-model="data.EmpId"
              @click="openEmp"
              @keydown.native.enter="openEmp"
              style="width: 180px"
            />
          </el-form-item>
        
          <el-form-item label="制单人">
            <span class="span" style="width: 180px">{{ data.MakeEmpName }}</span> 
          </el-form-item>
        </el-row>
      </el-form>

      <el-table
        border
        class="table_bottom table-line tb-c-head"
        :data="tableData"
        stripe
        style="margin-top: 18px"
        :row-class-name="tableRowClassName"
        @row-click="add"
      >
        <insert-row @on-insert="onInsert" />
        <el-table-column min-width="160" align="center" label="备注">
              <template slot-scope="{ row }">
                <span v-if="Status === 2">{{
                  row.Remark
                }}</span>
                <el-input
                  v-else
                  v-model="row.Remark"
                  @change="editT(row)"
                  placeholder="请输入备注"
                />
              </template>
            </el-table-column>
            <el-table-column
            label="工单解绑单号"
            prop="UnBindNo"
            align="center"
            min-width="160"
          >
          </el-table-column>
          <el-table-column
            label="转入工单号"
            prop="WorkDocNo"
            align="center"
            min-width="160"
          >
          </el-table-column>
        
        <el-table-column
          label="存货编码"
          prop="ProductNo"
          align="center"
          min-width="160"
        >
        </el-table-column>
        <el-table-column
          label="存货名称"
          prop="ProductName"
          align="center"
          min-width="100"
        >
          <template slot-scope="{ row }">
            <span class="not-edit" v-if="Status === 2">{{
              row.ProductName
            }}</span>
            <account-select
              v-else
              v-model="row.ProductName"
              :source="DAccount"
              @select="onSelect($event, row)"
              :pageSize="pageParams.pageSize"
              :pageIndex="pageParams.pageIndex"
              :listTotal="listTotal"
              @inputText="inputText($event, row)"
              @click.native="resetFun"
              @currentPage="currentPage($event, row)"
              :pageType="true"
            />
          </template>
        </el-table-column>
        <el-table-column
          label="规格型号"
          prop="ProductSpec"
          align="center"
          min-width="100"
        >
        </el-table-column>
        <el-table-column
          label="属性"
          prop="PropertyId"
          align="center"
          min-width="100"
          key="table1_6"
        >
          <template slot-scope="{ row }">
            <el-select
              v-if="row.UseProcess && Status !== 2"
              v-model="row.PropertyId"
              @change="editT(row)"
            >
              <el-option
                v-for="item in propertyList"
                :key="item.PropertyId"
                :label="item.PropertyName"
                :value="item.PropertyId"
              ></el-option>
            </el-select>
            <span class="not-edit" v-else>{{
              row.UseProcess ? row.PropertyName : ""
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="颜色"
          prop="ColorId"
          align="center"
          min-width="100"
          key="table1_7"
        >
          <template slot-scope="{ row }">
            <el-select
              v-if="row.UseColor && Status !== 2"
              v-model="row.ColorId"
              @change="editT(row)"
            >
              <el-option
                v-for="item in row.Colors"
                :key="item.ColorId"
                :label="item.ColorName"
                :value="item.ColorId"
                :disabled="item.Status==0"
              ></el-option>
            </el-select>
            <span class="not-edit" v-else>{{
              row.UseColor ? row.ColorName : ""
            }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="计量单位" min-width="120px">
          <template slot-scope="{ row }">
            <span >{{ row.UnitName }}</span>
          </template>
          <!--  -->
        </el-table-column>
        <el-table-column
          label="数量"
          prop="Quantity"
          align="center"
          min-width="100"
          key="table1_9"
        >
          <template slot-scope="{ row }">
            <span class="not-edit" v-if="Status === 2">{{ $commonJs.toThousands(row.Quantity) }}</span>
            <el-input
              type="number"
              v-else
              @change="changeQuantity($event, row)"
              v-model="row.Quantity"
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" align="center" width="80">
          <template slot-scope="{ row, $index }">
            <el-button
              type="text"
              @click="del(row, $index)"
              :disabled="Status === 2"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <div class="mtx10">
        <div class="flex">
          <div class="text el-form-item__label">备注</div>
          <el-input
            type="textarea"
            :autosize="{ minRows: 3 }"
            :disabled="Status === 2"
            v-model="data.Remark"
          ></el-input>
        </div>
      </div>

      <div class="mtx10">
        <div class="flex space-between">
          <div class="flex flex1">
            <div class="mrx18 center el-form-item__label">审核人</div>
            <div class="center el-form-item__label">{{ data.ReviewEmpName }}</div>
          </div>
          <div class="flex flex1">
            <div class="mrx18 center el-form-item__label">审核时间</div>
            <div class="center el-form-item__label">{{ $commonJs.toDateString(data.ReviewDate) }}</div>
          </div>
        </div>
      </div>
    </div>
    <emp-dialog ref="empDialog" in-dialog selectable @select="setEmp" />
    <edit-dialog ref="editDialog" @select="select" in-dialog />

  </div>
</template>
<script>
import accountSelect from "@/components/business/stock/select";
import optionMixins from "@/mixins/option";
import empDialog from "@/components/personnel/result/record/listDialog";
import editDialog from "@/components/business/stock/workshopallot/editDialog";
export default {
  mixins: [optionMixins],
  name: "editworkshopallot",
  components: {
    accountSelect,
    empDialog,
    editDialog,
  },
  data() {
    return {
      pdApi: require("@/api/ba/product").default,
      sourceTypeApi: require("@/api/ba/sourceType").default,
      code_api: require("@/api/sy/serialCode").default,
      api: require("@/api/stock/stWorkShopAllotDoc").default,
      propertyApi: require("@/api/ba/property").default,
      propertyList: [],
      Mode: 0,
      initDAccount: [],
      initTotal: 0,
      DAccount: [],
      listTotal: 0,
      pageParams: {
        pageSize: 7, //分页大小
        pageIndex: 1,
      },
      isSave: false,
      data: {
        DocId: 0,
        DocDate: this.$commonJs.getToday(),
        DocNo: "",
        EmpName: "",
        EmpId: 0,
        MakeEmpName: "",
        MakeEmpId: 0,
        ReviewEmpName: "",
        ReviewEmpId: 0,
        ReviewDate: "",
        Remark: "",
      },
      Status: 0,
      date: [],
      tableData: [
        {
          T: 0,
          DocId: 0,
          DocProductId: 0,
          ProductId: null,
          ProductNo: "",
          ProductName: "",
          ProductSpec: "",
          PropertyId: null,
          PropertyName: "",
          ColorId: null,
          Colors: [],
          ColorName: "",
          UnitId: null,
          UnitName: "",
          Quantity: null,
          Remark: "",
          UseColor: false,
          UseProcess: false,

          UnitId2: null,
          Quantity2: null,
          BaseQuantity: null,
          SubQuantity: null,
          BaseUnit: null,
          SubUnit: null,
          SourceId: null,
          SourceDtsId: null,
          TargetId: null,
          TargetDtsId: null,
          WorkDocNo: "",
          UnBindNo: "",
        },
      ],
      viewType: "create",
      delTableData: [],
    };
  },
  created() {
    this.init();
  },
  mounted() {
    this.viewType = this.$route.params.type;
    if (this.$route.params.type === "create") {
      this.getPreviewNo();
    } else if (this.$route.params.type === "edit") {
      this.editInit(this.$route.params.data);
    }
  },

  methods: {
    open(){
      this.$refs.editDialog.open().then(that => {
        that.getData();
      })
    },
    onInsert(e) {
      let { type, index } = e;

      this.interpolate(null, index, type);
    },
    interpolate(row, index, type = "") {
      let o = {
        T: 0,
        DocId: 0,
        DocProductId: 0,
        ProductId: null,
        ProductNo: "",
        ProductName: "",
        ProductSpec: "",
        PropertyId: null,
        PropertyName: "",
        ColorId: null,
        Colors: [],
        ColorName: "",
        UnitId: null,
        UnitName: "",
        Quantity: null,
        Remark: "",
        UseColor: false,
        UseProcess: false,

        UnitId2: null,
        Quantity2: null,
        BaseQuantity: null,
        SubQuantity: null,
        BaseUnit: null,
        SubUnit: null,
        SourceId: null,
        SourceDtsId: null,
        TargetId: null,
        TargetDtsId: null,
        WorkDocNo: "",
        DocNo: "",
      };
      if (type == "down") {
        index = index + 1;
      }
      this.tableData.splice(index, 0, o);
      let copy = JSON.parse(JSON.stringify(this.tableData));
      this.tableData = [];
      this.$nextTick(() => {
        this.tableData = copy;
      });
      console.log("this.tableData", this.tableData);
    },
    init() {

      const user = this.$store.state.user;
      if (user) {
        this.data.EmpId = user.empId;
        this.data.EmpName = user.name;
      }

      this.propertyApi
        .list({
          Status: 1,
        })
        .then((res) => {
          if (res.Code === 0) {
            this.propertyList = res.Data;
          }
        });

      this.pdApi
        .list({
          Status: 1,
          PageIndex: this.pageParams.pageIndex,
          pageSize: this.pageParams.pageSize,
        })
        .then((res) => {
          this.DAccount = res.Data;
          this.initDAccount = res.Data;
          this.listTotal = res.Count;
          this.initTotal = res.Count;
        });

      this.callOptionApi();
    },
    openEmp() {
      this.$refs.empDialog.open().then((that) => {
        that.getData();
      });
    },
    setEmp(data) {
      console.log(data);
      this.data.EmpId = data.EmpId;
      this.data.EmpName = data.EmpName;
    },
    editT(row) {
      if (row.T !== 0) {
        row.T = 1;
      }
    },
    editInit(data) {
      this.viewType = "edit";
      this.isSave = true;
      let {
        DocId,
        DocDate,
        DocNo,
        EmpName,
        EmpId,
        MakeEmpName,
        MakeEmpId,
        ReviewEmpName,
        ReviewEmpId,
        ReviewDate,
        Remark,
        Status,
        Products,
      } = data;

      this.data = {
        DocId,
        DocDate,
        DocNo,
        EmpName,
        EmpId,
        MakeEmpName,
        MakeEmpId,
        ReviewEmpName,
        ReviewEmpId,
        ReviewDate,
        Remark,
      };

      this.Status = Status;

      Products.forEach((item, index) => {
        item.T = null;
        item.PropertyId = item.PropertyId !== 0 ? item.PropertyId : null;
        item.ColorId = item.ColorId !== 0 ? item.ColorId : null;
        item.UnitId = item.UnitId !== 0 ? item.UnitId : null;
      });

      this.tableData = Products;

    },
    getPreviewNo(dateTime = "") {
      this.code_api.previewNo("车间调拨单", dateTime).then((res) => {
        if (res.Code == 0) {
          this.Mode = res.Data.Mode;
          this.data.DocNo = res.Data.PreviewNo;
        } else {
          this.$message.warning("获取车间调拨单编号失败");
        }
      });
    },
    changeQuantity(val, row){

      this.editT(row)
      
      row.Quantity = this.getQuantity(val)
    },
    // 选单结果
    select({DocNo, data, detailRow}){

      console.log('detailRow', detailRow)
      console.log('data', data)

      let o = {
        T: 0,
        DocId: 0,
        DocProductId: 0,
        ProductId: detailRow.ProductId,
        ProductNo: detailRow.ProductNo,
        ProductName: detailRow.ProductName,
        ProductSpec: detailRow.ProductSpec,
        PropertyId: detailRow.PropertyId,
        PropertyName: detailRow.PropertyName,
        ColorId: detailRow.ColorId,
        Colors: detailRow.Colors,
        ColorName: detailRow.ColorName,
        UnitId: detailRow.UnitId,
        UnitName: detailRow.UnitName,
        Quantity: detailRow.Quantity,
        Remark: detailRow.Remark,
        UseColor: detailRow.UseColor,
        UseProcess: detailRow.UseProcess,
        UnitId2: detailRow.UnitId2,
        Quantity2: detailRow.Quantity2,
        BaseQuantity: detailRow.BaseQuantity,
        SubQuantity: detailRow.SubQuantity,
        BaseUnit: detailRow.BaseUnit,
        SubUnit: detailRow.SubUnit,
        SourceId: detailRow.DocId,
        SourceDtsId: detailRow.DetailId, 
        TargetId: data.WorkDocId,
        WorkDocNo: data.WorkDocNo,
        UnBindNo: detailRow.DocNo,
      }
      console.log(DocNo, data)

      this.tableData.unshift(o);

      console.log('this.tableData', this.tableData)
    },
    onSelect(e, row) {
      row.Colors = [];
      row.Units = [];
      row.ColorId = null;
      row.PropertyId = null;
      row.ProductName = e.ProductName;
      row.ProductNo = e.ProductNo;
      row.ProductId = e.ProductId;
      row.ProductSpec = e.ProductSpec;
      row.Colors = e.Colors;
      row.Units = e.Units;
      row.UseColor = e.UseColor;
      row.UseProcess = e.UseProcess;
      row.Quantity = null;
      row.UnitId = null;
      row.UnitName = "";

      console.log('row', row)
      console.log('e', e)

      if(row.T !== 0){
        row.T = 1;
      }

      if(row.Units.length === 0){
        row.UnitId = e.SkUnitId;
        row.UnitName = e.SkUnitName;
      }else{
        let mainUnit = row.Units.filter(item => item.IsMain === true)
        if(mainUnit.length > 0){
          row.UnitId = mainUnit[0].UnitId;
          row.UnitName = mainUnit[0].UnitName;
        }
      }

      

    },
    resetFun() {
      this.pageParams.pageIndex = 1;
      this.DAccount = this.initDAccount;
      this.listTotal = this.initTotal;
    },
    currentPage({val, text1}, row) {
      console.log('触发 currentPage index', val)
      this.pageParams.pageIndex = val;
      this.pdApi.list({ pageIndex: val, pageSize: 7, Status: 1, ProductName: text1}).then((res) => {
        if (res.Code == 0) {
          this.DAccount = res.Data;
          this.listTotal = res.Count;
        }
      });
    },
    inputText(text, row) {
      console.log('触发 inputText index', text)
      row.ProductName = text;
      this.pdApi
        .list({ pageIndex: 1, pageSize: 7, ProductName: text, Status: 1, })
        .then((res) => {
          if (res.Code == 0) {
            this.DAccount = res.Data;

            this.listTotal = res.Count;
          }
        });
    },
    openPage() {
      this.$router.push({
        name: "workList",
      });
    },
    del(row, index) {
      this.$confirm("确认删除这条数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then((res) => {
        if (row.T !== 0) {
          row.T = 2;
          this.delTableData.push(row);
        }

        this.tableData.splice(index, 1);
        if (this.tableData.length === 0) {
          this.newLine();
        }
      });
    },
    newLine() {
      let o = {
        T: 0,
        DocId: 0,
        DocProductId: 0,
        ProductId: null,
        ProductNo: "",
        ProductName: "",
        ProductSpec: "",
        PropertyId: null,
        PropertyName: "",
        ColorId: null,
        Colors: [],
        ColorName: "",
        UnitId: null,
        UnitName: "",
        Quantity: null,
        Remark: "",
        UseColor: false,
        UseProcess: false,
        UnitId2: null,
        Quantity2: null,
        BaseQuantity: null,
        SubQuantity: null,
        BaseUnit: null,
        SubUnit: null,
        SourceId: null,
        SourceDtsId: null,
        TargetId: null,
        TargetDtsId: null,
        WorkDocNo: "",
        UnBindNo: "",
      };

      this.tableData.push(o);
    },
    tableRowClassName({ row, rowIndex }) {
      row.index = rowIndex;
    },
    add(row, column) {
      console.log('row', row, column)
      if (column.label === "操作" || this.Status === 2) {
        return;
      }
      if (row.index === this.tableData.length - 1) {
        this.newLine();
      }
    },
    reView1() {
      let id = this.data.DocId;
      this.api.examine(id).then((res) => {
        if (res.Code === 0) {
          this.$message({ type: "success", message: res.Msg });
          this.api.info(this.data.DocId).then((res) => {
            if (res.Code === 0) {
              this.$route.params.data = res.Data;
              this.editInit(res.Data);
            }
          });
        } else {
          this.$message({ type: "warning", message: res.Msg });
        }
      });
    },
    reView() {
      this.save(1)
    },
    cancelReView() {
      let id = this.data.DocId;
      this.api.cancelExamine(id).then((res) => {
        if (res.Code === 0) {
          this.$message({ type: "success", message: res.Msg });
          this.api.info(this.data.DocId).then((res) => {
            if (res.Code === 0) {
              this.$route.params.data = res.Data;
              this.editInit(res.Data);
            }
          });
        } else {
          this.$message({ type: "warning", message: res.Msg });
        }
      });
    },
    handleDelete() {
      let id = this.data.DocId;
      this.$confirm("确定删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then((res) => {
        this.api.delete({Id: id}).then((res) => {
          if (res.Code === 0) {
            this.$message({ type: "success", message: res.Msg });
            this.newAdd();
            // this.$emit('deleted')
          } else {
            this.$message({ type: "warning", message: res.Msg });
          }
        });
      });
    },
    getProducts(data) {
      let Products = [];
      data.forEach((item) => {
        let {
          T,
          DocId,
          DocProductId,
          ProductId,
          PropertyId,
          ColorId,
          UnitId,
          Quantity,
          Price,
          Amount,
          Remark,
          SourceId, 
          SourceDtsId, 
          TargetId,
        } = item;

        PropertyId = PropertyId ? PropertyId : 0;
        ColorId = ColorId ? ColorId : 0;
        UnitId = UnitId ? UnitId : 0;

        

        let o = {
          T,
          DocId,
          DocProductId,
          ProductId,
          PropertyId,
          ColorId,
          UnitId,
          Quantity,
          Price,
          Amount,
          Remark,
          SourceId, 
          SourceDtsId, 
          TargetId,
        };

        Products.push(o);
      });

      return Products;
    },
    save(type = 0) {
      //验证表单是否填写
      let yanzheng = ["DocDate", "DocNo", "EmpId", ];
      for (let key in this.data) {
        if (yanzheng.indexOf(key) !== -1 && !this.data[key]) {
          this.$message({ type: "warning", message: "表单未填写完整" });
          return;
        }
      }
      console.log('this.tableData', JSON.parse(JSON.stringify(this.tableData)))
      let Products = this.getProducts(this.tableData);

      Products = Products.filter((item) => {
        return item.T != null && item.ProductId !== 0 && item.ProductId != null;
      });

      if(Products.length <= 0 && this.data.DocId === 0){
        this.$message({ type: "warning", message: "明细列表不能为空" });
        return 
      }
      
     
     
      
     

      // this.data.Requirement = "";
      let sub = JSON.parse(JSON.stringify(Products))
      console.log("sub",sub);
      // 等于空设置为0
      sub.forEach(item => {
        Object.keys(item).forEach(key => {
          if (item[key] == null ) {
            item[key] = 0;
          }
        })
      })
      
      let ProductsLength = sub.length;
      for (let i = 0; i < ProductsLength; ++i) {
        if(Products[i].UseColor && Products[i].ColorId === 0){
          this.$message.error(`存货${Products[i].ProductName}未填写颜色`)
          return;
        }
        // if(Products[i].UseProcess && Products[i].PropertyId === 0){
        //   this.$message.error(`存货${Products[i].ProductName}未填写属性`)
        //   return;
        // }
        if (!sub[i].Quantity) {
          this.$message({ type: "warning", message: "存货数量不能为0或为空" });
          return;
        }
      }
      sub = sub.concat(this.delTableData);

      let o = {
        Products:sub,
        ...this.data,
      };
      
      this.api.save(o).then((res) => {
        if (res.Code === 0) {
          if (this.viewType === "create") {
            this.data.DocId = res.Data;
          }
          if(type !== 1){
            this.$message.success(res.Msg);
          }
          this.isSave = true;

          this.api.info(this.data.DocId).then((res) => {
            if (res.Code === 0) {
              this.$route.params.data = res.Data;
              if(type === 1){
                this.reView1()
              }else{
                this.editInit(res.Data, 'keep');
              }
              
            }
          });
        } else {
          this.$message({ type: "warning", message: res.Msg });
        }
      });
    },
    newAdd() {
      if (!this.isSave) {
        this.$message({ type: "warning", message: "请先进行保存再操作" });
        return;
      } else {
        Object.assign(this.$data, this.$options.data.call(this));
        this.getPreviewNo();
        this.$route.params.type = "create";
        this.viewType = "create";
        this.init();
        this.isSave = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.dropdown-item {
  padding: 6px;
}

.mtx10 {
  padding: 10px;
}

.flex {
  display: flex;
  .text {
    width: 60px;
  }
}
.space-between {
  justify-content: space-between;
}

.center {
  display: flex;
  justify-content: center;
  align-items: center;
}

.flex1 {
  flex: 1;
}

.mrx18 {
  margin-right: 18px;
}
.span {
  display: inline-block;
  width: 180px;
}
</style>
